import { levelDetails } from "../../consts/avatarMap"

export default function Avatar({ level, getImage=true, ...props }) {
    if (getImage) return <img src={ levelDetails?.[level].avatar } style={{ ...props?.sx, maxWidth: 200 }} {...props} />
    else return ( levelDetails?.[level].rank )
}